// /////////////////////////////
// Contact page form
// /////////////////////////////
// document
//   .getElementById("ContactForm")
//   ?.addEventListener("submit", function (event) {
//     event.preventDefault();

//     var formData = new FormData(this);
//     var url =
//       "https://script.google.com/macros/s/AKfycbylZZGL_aFIs93FlNwX1l5tHbNdzMi6a-1IEra7mHXRPKlhpFDGYq4ocN6lx7N-ok0P/exec";

//     fetch(url, {
//       method: "POST",
//       body: formData,
//     })
//       .then((response) => response.text())
//       .then((data) => {
//         // document.getElementById('formMessage').innerHTML = data;
//         document.getElementById(
//           "formMessage"
//         ).innerHTML = `<div class="form-message success" role="status" tabindex="-1" autofocus>
//         <p class="form-message-title" tabindex="-1">
//          Thankyou. We will get back to you.
//         </p>
//       </div>`;
//       })
//       .catch((error) => {
//         document.getElementById("formMessage").innerHTML = `
//         <div class="form-message error">
//           <div class="form-message-title">There was an error with the form submission. Please try again.</div>
//         </div>

//       `;
//       });
//   });

// ////////////////////////////////////////
// B2B PAGE FORM --> Dealers contact sheet
// ///////////////////////////////////////

document
  .getElementById("ContactFormB2B")
  ?.addEventListener("submit", function (event) {
    event.preventDefault();

    var formDataB2B = new FormData(this);
    var url =
      "https://script.google.com/macros/s/AKfycbz3MU-UcUKkub5tsobzX47LxSHZv5-HBShamAu9lhhmo_viETuli6ytmtmMHBEN7POThQ/exec";

    fetch(url, {
      method: "POST",
      body: formDataB2B,
    })
      .then((response) => response.text())
      .then((data) => {
        // document.getElementById('formMessage').innerHTML = data;
        document.getElementById(
          "formMessageB2B"
        ).innerHTML = `<div class="form-message success" role="status" tabindex="-1" autofocus>
        <p class="form-message-title" tabindex="-1">
         Thankyou. We will get back to you.
        </p>
      </div>`;
      })
      .catch((error) => {
        document.getElementById("formMessageB2B").innerHTML = `
        <div class="form-message success">
          <div class="form-message-title">Thankyou. We will get back to you.</div>
        </div>

      `;
      });
  });

// /////////////////////////////
// ACCOUNT PAGE GST FORM
// /////////////////////////////
document
  .getElementById("ContactFormGST")
  ?.addEventListener("submit", function (event) {
    event.preventDefault();

    var formData = new FormData(this);
    var url =
      "https://script.google.com/macros/s/AKfycbyXRQrAukTMAuntAanzQUKdLHuYIJUAbijirj1vedE-aLuz2MsADdDYFbzuMfiEgCrR/exec";

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.text())
      .then((data) => {
        // document.getElementById('formMessage').innerHTML = data;
        document.getElementById(
          "formMessageGST"
        ).innerHTML = `<div class="form-message success" role="status" tabindex="-1" autofocus>
        <p class="form-message-title" tabindex="-1">
         Thankyou. We will get back to you.
        </p>
      </div>`;
      })
      .catch((error) => {
        document.getElementById("formMessageGST").innerHTML = `
         <div class="form-message success">
          <div class="form-message-title">${error.message || error}</div>
        </div>
        
      `;
      });
  });
// /////////////////////////////
// SME Contact Sheet
// /////////////////////////////
document
  .getElementById("ContactFormSME")
  ?.addEventListener("submit", function (event) {
    event.preventDefault();

    var formData = new FormData(this);
    var url =
      "https://script.google.com/macros/s/AKfycbzmq5OIfvWZeI0MVEGeB_XXe8XV9cuzDl_TYpxvgFngyHF9U6vlEE3DbqXQdLf1gGJU1w/exec";

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.text())
      .then((data) => {
        // document.getElementById('formMessage').innerHTML = data;
        document.getElementById(
          "formMessageSME"
        ).innerHTML = `<div class="form-message success" role="status" tabindex="-1" autofocus>
        <p class="form-message-title" tabindex="-1">
         Thankyou. We will get back to you.
        </p>
      </div>`;
      })
      .catch((error) => {
        document.getElementById("formMessageSME").innerHTML = `
         <div class="form-message success">
          <div class="form-message-title">Thankyou. We will get back to you.</div>
        </div>
        
      `;
      });
  });

// ///////////////////////////////////////////
// Institute Contact Sheet --> Institute page
// //////////////////////////////////////////

document
  .getElementById("ContactFormInstitute")
  ?.addEventListener("submit", function (event) {
    event.preventDefault();

    var formData = new FormData(this);
    var url =
      "https://script.google.com/macros/s/AKfycbyOZlN8DnBPedhg7vteItoxE1-o2_15nMmkxUhlGIUPKfe0gEIQWg7GKbCGh_8x1hKGCw/exec";

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.text())
      .then((data) => {
        // document.getElementById('formMessage').innerHTML = data;
        document.getElementById(
          "formMessageInstitute"
        ).innerHTML = `<div class="form-message success" role="status" tabindex="-1" autofocus>
        <p class="form-message-title" tabindex="-1">
         Thankyou. We will get back to you.
        </p>
      </div>`;
      })
      .catch((error) => {
        document.getElementById("formMessageInstitute").innerHTML = `
         <div class="form-message success">
          <div class="form-message-title">Thankyou. We will get back to you.</div>
        </div>
        
      `;
      });
  });

// ///////////////////////////////////////////
// Business Contact Sheet --> Other business page
// //////////////////////////////////////////
document
  .getElementById("ContactFormBusiness")
  ?.addEventListener("submit", function (event) {
    event.preventDefault();

    var formData = new FormData(this);
    var url =
      "https://script.google.com/macros/s/AKfycbw_JSHB9zsn1xQFpWiKM76kIgvRWnKVEowdQTLOm5ZPMEqMYIrmeSQx8iLVkpW9deAEQw/exec";

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.text())
      .then((data) => {
        // document.getElementById('formMessage').innerHTML = data;
        document.getElementById(
          "formMessageBusi"
        ).innerHTML = `<div class="form-message success" role="status" tabindex="-1" autofocus>
        <p class="form-message-title" tabindex="-1">
         Thankyou. We will get back to you.
        </p>
      </div>`;
      })
      .catch((error) => {
        document.getElementById("formMessageBusi").innerHTML = `
       <div class="form-message success" role="status" tabindex="-1" autofocus>
        <p class="form-message-title" tabindex="-1">
         Thankyou. We will get back to you.
        </p>
      </div>
        
      `;
      });
  });

// ///////////////////////////////////////////
// Campus ambassador - campus page
// //////////////////////////////////////////
document
  .getElementById("ContactFormAmbassador")
  ?.addEventListener("submit", function (event) {
    event.preventDefault();

    var formData = new FormData(this);
    var url =
      "https://script.google.com/macros/s/AKfycbzTJONLuF0vwixi97lE0o0E3dMbDiFD6pCw8LnntNsWEXXFP1yPyvJXSO_CwIN_dJwo/exec";

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.text())
      .then((data) => {
        // document.getElementById('formMessage').innerHTML = data;
        document.getElementById(
          "formMessageBusi"
        ).innerHTML = `<div class="form-message success" role="status" tabindex="-1" autofocus>
        <p class="form-message-title" tabindex="-1">
         Thankyou. We will get back to you.
        </p>
      </div>`;
      })
      .catch((error) => {
        document.getElementById("formMessageBusi").innerHTML = `
       <div class="form-message success" role="status" tabindex="-1" autofocus>
        <p class="form-message-title" tabindex="-1">
         Thankyou. We will get back to you.
        </p>
      </div>
        
      `;
      });
  });

// ////////////////////////////////////////
// B2B LEAD GENERATION
// ///////////////////////////////////////

document.addEventListener("DOMContentLoaded", function () {
  document
    .getElementById("ContactFormB2BLeads")
    ?.addEventListener("submit", function (event) {
      event.preventDefault();
      var form = this;
      var formDataB2B = new FormData(this);
      var url =
        "https://script.google.com/macros/s/AKfycbzYkYolAVCmHM4NgKszzeOarcBYdZcs1Uwu0aWE3tH8n5sctXP-e900g8_kD0B0RNgn/exec";

      // Show loader
      document.getElementById("formLoaderB2B").style.display = "block";

      fetch(url, {
        method: "POST",
        body: formDataB2B,
      })
        .then((response) => response.text())
        .then((data) => {
          // Hide loader
          document.getElementById("formLoaderB2B").style.display = "none";

          // Show success message
          document.getElementById(
            "formMessageB2B2"
          ).innerHTML = `<div class="form-message success" role="status" tabindex="-1" autofocus>
            <p class="form-message-title" tabindex="-1">
              Thank you. We will get back to you.
            </p>
          </div>`;

          // Reset form fields
          form.reset();
        })
        .catch((error) => {
          // Hide loader
          document.getElementById("formLoaderB2B").style.display = "none";

          // Show fallback message
          document.getElementById("formMessageB2B2").innerHTML = `
            <div class="form-message success">
              <div class="form-message-title">Thank you. We will get back to you.</div>
            </div>
          `;

          // Reset form fields
          form.reset();
        });
    });
});
